import { KText } from '@/ui-library/components';
import { Flex, Icon, Tooltip } from '@chakra-ui/react';
import { PiSmileySadDuotone } from 'react-icons/pi';
import { PiCalendarXDuotone } from 'react-icons/pi';

export const SchInterviewerCalNotConnected = ({ children = undefined }) => {
  return (
    <Tooltip
      placement="left"
      bg="#FFF"
      borderRadius="6px"
      boxShadow="0px 71px 29px rgba(215, 218, 235, 0.01), 0px 40px 24px rgba(215, 218, 235, 0.05), 0px 18px 18px rgba(215, 218, 235, 0.09), 0px 4px 10px rgba(215, 218, 235, 0.1)"
      label={
        <Flex flexDir="column" p="12px" gap="8px">
          <Flex gap="6px">
            <Icon
              w="20px"
              h="20px"
              // @ts-expect-error -- pre-existing type debt (extraction move)
              as={PiSmileySadDuotone}
              color="secondary-700"
            />
            <KText>Calendar not connected. Events not visible.</KText>
          </Flex>
          {/* <KText>
            This interviewer’s events are not displayed because of their
            calendar’s event visibility settings
          </KText> */}
        </Flex>
      }
      shouldWrapChildren
    >
      {children || (
        <Icon
          // @ts-expect-error -- pre-existing type debt (extraction move)
          as={PiCalendarXDuotone}
          w="16px"
          h="16px"
          color="secondary-700"
          onClick={(e) => e.stopPropagation()}
        />
      )}
    </Tooltip>
  );
};
